import dashboard from './dashboard.js';
import { Router } from '@/legacy/Router';

Router.get('gallery/?(entrant|manager|judge|home)?$', dashboard);
